import * as React from 'react';
import { getString } from '../../../../web/utils/stringLoader';

interface IframeProps {
    articleUrl: string;
    isClientApp: boolean;
    addToHistory: (href: string) => void;
    disableBackButton: (disabled: boolean) => void;
}

export class ArticleIframe extends React.Component<IframeProps, any> {
    private iframe: HTMLIFrameElement;
    private updateKey: number = 0;
    public constructor(props: any) {
        super(props);
    }

    public shouldComponentUpdate(nextProps: IframeProps) {
        if (nextProps.articleUrl === this.iframe.contentWindow.location.href) {
            return false;
        } else {
            this.updateKey++;
            return true;
        }
    }

    public componentDidMount() {
      if (this.props.isClientApp) {
        this.iframe.src = this.iframe.src;
      }
    }

    public componentDidUpdate() {
      this.componentDidMount();
  }

    public render() {
      return (
        <div className={'ocSearchIFrameDiv'}>
          <iframe
            title={getString('L_Article_MainContent_RoleDescription')}
            key={this.updateKey}
            ref={this.initializeIframeRef}
            onLoad={this.handleOnLoad}
            id="ocSearchIFrame"
            className="ocSearchIFrame"
            frame-border="0"
            sandbox="allow-scripts allow-presentation allow-popups allow-modals allow-top-navigation"
            style={{ display: 'block', overflow: 'auto' }}
            src={this.props.articleUrl}
            allowFullScreen={true}
          />
        </div>
      );
    }

    private iframeStartLoading = () => {
        this.props.disableBackButton(true);
    };

    private handleOnLoad = () => {
      this.props.disableBackButton(false);
      const iframeSrc = this.iframe.contentWindow.location.href;
      this.props.addToHistory(iframeSrc);

      this.iframe.contentWindow.onunload = this.iframeStartLoading;
    };

    private initializeIframeRef = (ref: HTMLIFrameElement) => {
        if (ref) {
            this.iframe = ref;
        }
    };
}
